import React from 'react';
import { TrendingUp } from 'lucide-react';

const GraficoResultados = ({ locais, totalVotos }) => {
  if (!locais || locais.length === 0) return null;

  // Ordena por votos (decrescente)
  const locaisOrdenados = [...locais].sort((a, b) => b.votos - a.votos);

  // Medalhas para top 3
  const getMedalha = (posicao) => {
    switch(posicao) {
      case 0: return '🏆';
      case 1: return '🥈';
      case 2: return '🥉';
      default: return '';
    }
  };

  // Cores para as barras
  const getCor = (posicao) => {
    const cores = [
      'from-yellow-400 to-amber-500',      // 1º - Dourado
      'from-gray-300 to-gray-400',         // 2º - Prata
      'from-orange-400 to-orange-500',     // 3º - Bronze
      'from-blue-400 to-blue-500',         // 4º
      'from-purple-400 to-purple-500',     // 5º
      'from-pink-400 to-pink-500',         // 6º
    ];
    return cores[posicao] || 'from-gray-400 to-gray-500';
  };

  return (
    <div className="mb-8">
      {/* Título da seção */}
      <div className="flex items-center justify-center gap-3 mb-6">
        <TrendingUp className="w-6 h-6 text-primary-600" />
        <h3 className="text-2xl font-bold text-gray-900">
          Ranking Completo
        </h3>
      </div>

      {/* Container do gráfico */}
      <div className="bg-white rounded-xl shadow-lg p-6 space-y-4">
        {locaisOrdenados.map((local, index) => {
          const porcentagem = totalVotos > 0 
            ? ((local.votos / totalVotos) * 100).toFixed(1) 
            : 0;
          
          const isVencedor = index === 0;
          const isTop3 = index < 3;

          return (
            <div 
              key={local.local}
              className={`
                transition-all duration-300 hover:scale-[1.02]
                ${isVencedor ? 'bg-yellow-50 border-2 border-yellow-300 rounded-xl p-4' : 'p-2'}
              `}
            >
              {/* Header da barra */}
              <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
                <div className="flex items-center gap-2 flex-1 min-w-0">
                  <span className={`
                    text-2xl flex-shrink-0
                    ${isTop3 ? 'animate-pulse' : ''}
                  `}>
                    {getMedalha(index)}
                  </span>
                  <span className={`
                    font-semibold flex-shrink-0
                    ${isVencedor ? 'text-lg text-yellow-900' : 'text-base text-gray-700'}
                  `}>
                    {index + 1}º
                  </span>
                  <span className={`
                    truncate
                    ${isVencedor ? 'text-lg font-bold text-gray-900' : 'text-base text-gray-800'}
                  `}>
                    {local.nome}
                  </span>
                </div>
                
                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className={`
                    font-bold
                    ${isVencedor ? 'text-lg text-gray-900' : 'text-sm text-gray-700'}
                  `}>
                    {local.votos.toLocaleString('pt-BR')}
                  </span>
                  <span className={`
                    px-3 py-1 rounded-full font-bold
                    ${isVencedor 
                      ? 'bg-yellow-400 text-yellow-900 text-base' 
                      : 'bg-gray-100 text-gray-700 text-sm'
                    }
                  `}>
                    {porcentagem}%
                  </span>
                </div>
              </div>

              {/* Barra de progresso */}
              <div className="relative w-full bg-gray-200 rounded-full h-10 overflow-hidden shadow-inner">
                <div
                  className={`
                    h-10 rounded-full transition-all duration-1000 ease-out
                    bg-gradient-to-r ${getCor(index)}
                    flex items-center justify-end pr-4
                    ${isVencedor ? 'shadow-lg' : ''}
                  `}
                  style={{ 
                    width: `${porcentagem}%`,
                    minWidth: parseFloat(porcentagem) > 5 ? `${porcentagem}%` : '5%'
                  }}
                >
                  {parseFloat(porcentagem) > 8 && (
                    <span className="text-white font-bold text-sm drop-shadow-md">
                      {porcentagem}%
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GraficoResultados;
